/* eslint-disable max-len */
import React from 'react';

const ChevRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16">
    <g fill="none">
      <g fill="#5A5A5A">
        <g>
          <g>
            <g>
              <path
                d="M4.688 0c.24 0 .48.098.663.293l6.562 7c.367.391.367 1.023 0 1.414l-6.562 7c-.367.391-.96.391-1.326 0-.367-.391-.367-1.023 0-1.414L9.925 8l-5.9-6.293c-.367-.391-.367-1.023 0-1.414C4.208.098 4.448 0 4.688 0"
                transform="translate(-1284 -883) translate(0 600) translate(1022 87) translate(262 196)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default ChevRight;
